import Vue from "vue";
import axios from "axios";

export default {
  namespaced: true,
  state: {
    application_types: [],
    loading: false,
  },
  getters: {
    application_types: (state) => state.application_types,
    loading: (state) => state.loading,
  },
  mutations: {
    SET_APPLICATION_TYPES(state, payload) {
      state.application_types = payload
    },
    RESET_APPLICATION_TYPES(state) {
      state.application_types = []
    },
    BEGIN_LOADING(state) {
      state.loading = true
    },
    END_LOADING(state) {
      state.loading = false
    }
  },
  actions: {
    async loadApplicationTypes({commit}, application) {
      if (application.campaign) {
        commit("BEGIN_LOADING")
        const params = {
          campaign_id: application.campaign.id,
        };

        await axios.get('https://portal.kuzstu.ru/api/abit_application_types/', {params})
          .then((application_types) => {
            if (application_types.data.length) {
              Vue.axios.get('application/application_types/')
                .then((response) => {
                  let result = response.data.filter(data => {
                    return application_types.data.includes(data.id)
                  })
                  commit('SET_APPLICATION_TYPES', result)
                  commit('END_LOADING')
                })
            }
          })
      }
    },
  }
}
